import { SECRET_KEY } from "./file-signing";

export async function signString(input: string): Promise<string> {
    const dataBuffer = new TextEncoder().encode(input);
    const keyBuffer = new TextEncoder().encode(SECRET_KEY);

    const key = await crypto.subtle.importKey(
        "raw",
        keyBuffer,
        { name: "HMAC", hash: "SHA-256" },
        false,
        ["sign"]
    );

    const signature = await crypto.subtle.sign("HMAC", key, dataBuffer);
    return Array.from(new Uint8Array(signature))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
}
